<template>
  <v-app>
    <v-main>
      <v-layout column fill-height v-if="!getenableADA">
        <appHeader v-if="getKioskId !== undefined"></appHeader>
        <v-fade-transition leave-absolute>
          <router-view />
        </v-fade-transition>
      </v-layout>
      <v-layout column fill-height v-else>
        <v-fade-transition leave-absolute>
          <router-view />
        </v-fade-transition>
        <appHeader></appHeader>
      </v-layout>
    </v-main>
    <image-viewer></image-viewer>
    <email-viewer></email-viewer>
    <options-viewer></options-viewer>
    <session-end-viewer></session-end-viewer>
    <telepresence-viewer></telepresence-viewer>
    <recognition></recognition>
    <snack-bar></snack-bar>
    <JuryOptionsViewer></JuryOptionsViewer>
    <JuryImageViewer></JuryImageViewer>
    <ThinkingViewer></ThinkingViewer>
  </v-app>
</template>

<script>
import appHeader from "@/components/appHeader.vue";
import imageViewer from "@/components/dialogs/imageViewer";
import emailViewer from "@/components/dialogs/emailViewer";
import optionsViewer from "@/components/dialogs/optionsViewer";
import SessionEndViewer from "./components/dialogs/sessionEndViewer.vue";
import recognition from "@/components/recognition.vue";
import { mapGetters } from "vuex";
import TelepresenceViewer from './components/dialogs/telepresenceViewer.vue';
import SnackBar from './components/snackBar.vue';
import router from '@/router';
import JuryOptionsViewer from "./components/dialogs/juryOptionsViewer.vue";
import JuryImageViewer from "./components/dialogs/juryImageViewer.vue";
import ThinkingViewer from "./components/dialogs/thinkingViewer.vue";
export default {
  name: "App",
  data() {
    return {
      count: 0,
    };
  },
  components: {
    appHeader,
    recognition,
    imageViewer,
    emailViewer,
    optionsViewer,
    SessionEndViewer,
    TelepresenceViewer,
    SnackBar,
    JuryOptionsViewer,
    JuryImageViewer,
    ThinkingViewer
  },
  computed: {
    ...mapGetters([
      "appDimensions",
      "getKioskId",
      "getStartUserSession",
      "getTouchCount",
      "isUserLooking",
      "getenableADA",
      "getAvatarDetails",
      "getNetworkConnection"
    ]),
  },
  created() {
    window.onclick = () => {
      if (this.getTouchCount === 1 && !this.isUserLooking) {
        this.$store.dispatch("resetKiosk");
      } else if (this.getTouchCount !== 0) {
        this.$store.commit("setTouchCount", this.getTouchCount + 1);
      }
      if (this.getTouchCount > 1 && !this.isUserLooking) {
        this.$store.dispatch("clearResetTimeout").then(() => {
          this.$store.dispatch("resetKiosk");
        });
      }
    };
  },
  watch: {
    getNetworkConnection(newVal) {
      if (newVal) {
        this.$store.commit('setTextBubbleText', "Hi, my name is " + this.getAvatarDetails.avatarName + ", I’m here to help you. Tap the microphone button, and ask me ‘What can you do?’")
      }
    }
  },
  mounted() {
    window["console"]["log"] = function () { };
    console.warn = function () { };
    console.error = function () { };
    setInterval(() => {
      if (navigator.onLine) {
        this.$store.commit('setNetworkConnection', true)
      } else {
        this.$store.commit('setNetworkConnection', false)
        this.$store.commit('setTextBubbleText', "No internet connectivity. Please use the touch interface.")
      }

    }, 1000)
  }
};
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  background-color: #F5F3F0 !important;
}

body::-webkit-scrollbar {
  display: none;
}

.v-card::-webkit-scrollbar {
  -webkit-appearance: none;
  color: #d37444 !important;
  width: 10px;
}

.v-card::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px #d37444 !important;
}

.v-list::-webkit-scrollbar {
  -webkit-appearance: none;
  color: #d37444 !important;
  width: 10px;
}

.v-list::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px #d37444 !important;
}

.v-virtual-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
  color: #d37444 !important;
  width: 10px;
}

.v-virtual-scroll::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px #d37444 !important;
}

.v-dialog {
  margin-top: 100px;
}
</style>
